<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  mounted() {
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", "中文");
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
html,
body {
  margin: 0;
  padding: 0;
}
/deep/.el-carousel__item[data-v-df660e5c]:nth-child(2n + 1) {
  background-color: rgba(0, 0, 0, 0);
}

* {
  ::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
}
</style>
